export const USER_LOCAL_STORAGE_KEY = 'ambitWebChatUser';
export const CONVERSATION_ID_LOCAL_STORAGE_KEY = 'ambitConversationId';
export const CHAT_STARTS_OPEN_LOCAL_STORAGE_KEY = 'ambitChatStartOpen';
export const CLEAR_HISTORY_TIMESTAMP_LOCAL_STORAGE_KEY = 'ambitClearHistoryTimestamp';
export const THUMBSUP = 'thumbsup';
export const THUMBSDOWN = 'thumbsdown';



// WEBPACK FOOTER //
// ./src/initialiser/constants.js